export default "__VITE_ASSET__306be268__"